<template>
  <!--  -->
  <div class="solution-template">
    <list-page>
      <search-condition @search="resetSearch" :show-border="false" :show-shadow="false">
        <template #default>
          <el-input v-model="searchInfo.searchKey" placeholder="请输入查询关键字" @keydown.enter="resetSearch">
            <template #prefix>关键字</template>
          </el-input>
        </template>
        <template #option>
          <page-button type="read" el-type="primary" @click="resetSearch">查询</page-button>
          <page-button type="write" el-type="success" @click="router.push(`/qywx/quotation/solution/detail`)">新建</page-button>
        </template>
      </search-condition>
      <list-table :show-shadow="false">
        <yq-table :data="dataList" height="100%" stripe border >
          <yq-table-column  label="方案名称" prop="solutionName" min-width="180rem"/>
          <yq-table-column  label="方案类型" prop="solutionType">
            <template v-slot="{row}">
              <span v-if="row.solutionType === 1">通用方案</span>
              <span v-if="row.solutionType === 2">定制方案</span>
            </template>
          </yq-table-column>
          <yq-table-column  label="推荐规则" prop="solutionRule">
            <template v-slot="{row}">
              <span v-for="item in ruleList" :key="item.value">
                <span v-if="item.value === row.solutionRule">{{item.name}}</span>
              </span>
            </template>
          </yq-table-column>
          <yq-table-column label="创建时间" prop="createdTime" width="180rem"/>
          <yq-table-column  label="操作" prop="options" :align="'center'" fixed="right" width="120rem" :show-overflow-tooltip="false">
            <template v-slot="{row}">
              <table-button-group label="更多操作">
                <table-button @click="router.push(`/ai-quote/quotation/solution/detail?id=${row.id}`)">编辑</table-button>
                <table-button  el-type="danger" message="是否确认删除数据">删除</table-button>
              </table-button-group>
            </template>
          </yq-table-column>
        </yq-table>
      </list-table>
      <form-page v-model:page-number="searchInfo.pageNumber" v-model:page-size="searchInfo.pageSize" :total-count="searchInfo.totalCount" @onLoad="queryList" :show-border="false" :show-shadow="false"/>
    </list-page>
  </div>
</template>

<script>

import SearchCondition from "@/components/h5/layout/SearchCondition";
import FormPage from "@/components/h5/layout/FormPage";
import ListTable from "@/components/h5/layout/ListTable.vue";
import ListPage from "@/components/h5/layout/ListPage";
import TableButton from "@/components/h5/button/TableButton";
import TableButtonGroup from "@/components/h5/button/TableButtonGroup.vue";
import YqTableColumn from "@/components/h5/table/YqTableColumn.vue";
import Util from "@/util/util";
import {useRoute, useRouter} from "vue-router";
import qywxXbotSolutionApi from "@/api/dz-ai/qywxXbotSolutionApi";
import solutionRule from "./solutionRule.json";
export default {
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "",
  components: {
    YqTableColumn, TableButtonGroup, TableButton, SearchCondition, FormPage, ListTable, ListPage
  },
  data() {
    return {
      searchInfo: {},
      dataList: [],
      ruleList: [],
    };
  },

  created() {
    this.resetSearch();
    this.ruleList = solutionRule;
  },
  methods: {
    queryList() {
      qywxXbotSolutionApi.queryList(this.searchInfo).then(res => {
        this.dataList = res.records;
        this.searchInfo.totalCount = res.total;
      })
    },
    resetSearch() {
      this.searchInfo.pageNumber = 1;
      this.queryList();
    },
  }
};
</script>

<style lang="scss" scoped>
.solution-template{
  height: 100%;
}
</style>